import { courseService } from '@/services/courseService';

/**
 * Lấy thông tin chi tiết khóa học
 */
export const getCourseDetail = async (courseId: string) => {
  try {
    const course = await courseService.getCourseById(courseId);
    
    if (!course) {
      throw new Error('Không tìm thấy khóa học');
    }
    
    return course;
  } catch (error: any) {
    console.error(`Error fetching course ${courseId}:`, error);
    throw error;
  }
}; 